import React from 'react';
import { getProvider } from '../registry';

// Single render surface for every affiliate link on the site. Owns
// rel="sponsored noopener noreferrer" + target="_blank" + analytics
// hooks so per-button code can't forget them, and returns null when the
// provider can't build a URL for the target (e.g. vendor doesn't carry
// the card). Add new placements by calling <AffiliateLink/> — never by
// hand-rolling an <a href="…partner.tcgplayer.com…">.
//
// Props:
//   provider:  provider id ('tcgplayer', …)
//   target:    { kind: 'card', card }
//            | { kind: 'cart', deck }
//            | { kind: 'search', query }
//            | { kind: 'wrap',   url   }
//   placement: short label for analytics segmentation
//              (e.g. 'printslist', 'upgradelizer', 'deckcart')
//   sharedId:  optional Impact "sharedid" param
//   className: extra class on the rendered <a>
//   onClick:   optional click hook for analytics — fires alongside navigation
export function AffiliateLink({
    provider: providerId,
    target,
    placement,
    sharedId,
    className,
    children,
    onClick,
    title,
    'aria-label': ariaLabel,
}) {
    const provider = getProvider(providerId);
    if (!provider || !target) return null;
    const ctx = { placement, sharedId };
    let href = null;
    switch (target.kind) {
        case 'card':
            href = provider.cardUrl(target.card, ctx);
            break;
        case 'cart':
            href = provider.cartUrl(target.deck, ctx);
            break;
        case 'search':
            href = provider.searchUrl(target.query, ctx);
            break;
        case 'wrap':
            href = provider.wrap(target.url, ctx);
            break;
        default:
            href = null;
    }
    if (!href) return null;
    return (
        <a
            className={className}
            href={href}
            target="_blank"
            rel="sponsored noopener noreferrer"
            title={title}
            aria-label={ariaLabel}
            onClick={(e) => {
                if (onClick) onClick(e, { provider: provider.id, placement });
            }}
        >
            {children}
        </a>
    );
}
